import { createValidation } from '_metronic/helpers'
import { TFunction } from '_metronic/i18n/Metronici18n'
import * as Yup from 'yup'

export const lotacaoSchema = (t: TFunction, isEditing: boolean) => {
  const v = createValidation(t)

  return Yup.object().shape({
    unidade: isEditing
      ? Yup.object().nullable()
      : Yup.object().nullable().required(v.requiredField('unidade_setor', 'select')),
    cbo: Yup.object().nullable(),
    ine: Yup.string()
      .matches(/^\d{10}$/, {
        message: 'INE deve conter exatamente 10 dígitos numéricos',
        excludeEmptyString: true,
      })
      .notRequired(),
  })
}
